import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LoginComponent } from '../../authorization/login/login.component';
import { ToqqerRegisterComponent } from '../../authorization/toqqer-register/toqqer-register.component';
import { OtherRegistrationComponent } from '../../authorization/other-registration/other-registration.component';

@Component({
  selector: 'app-login-show',
  templateUrl: './login-show.component.html',
  styleUrls: ['./login-show.component.css']
})
export class LoginShowComponent implements OnInit {

  constructor(
    private dialog:MatDialog
  ) { }

  ngOnInit(): void {
  }

  // login(){
  //   const dialogRef = this.dialog.open(LoginComponent,{
  //     panelClass: 'custom-dialog-panel',
  //     backdropClass: 'custom-backdrop'
  //   });

  //   dialogRef.afterClosed().subscribe(result => {
  //     console.log('The dialog was closed');
  //   });
  // }

  // register(){
  //   const dialogRef = this.dialog.open(ToqqerRegisterComponent);

  //   dialogRef.afterClosed().subscribe(result => {
  //     console.log('The dialog was closed')
  //   })
  // }
}
